import React from 'react';
import Container from '@mui/material/Container';
import { useDispatch, useSelector } from 'react-redux';
import ExerciseEncouragementMessageForm
  from '../../../components/forms/ExerciseEncouragementMessageForm';
import PageCircularProgress from '../../../components/PageCircularProgress/PageCircularProgress';
import {
  getExerciseEncouragementMessages,
} from '../../../store/exerciseEncouragementMessage/action';
import PageTitle from '../../../components/PageTitle/PageTitle';
import { useUserAuth } from '../../../contexts/UserAuthContext.js';

export default function AddExerciseEncouragementMessagePage() {
  const {
    pending,
    content,
    error,
  } = useSelector((state) => state.exerciseEncouragementMessage);
  const dispatch = useDispatch();
  const { token } = useUserAuth();

  if (!content && !pending && !error) {
    dispatch(getExerciseEncouragementMessages(token));
  }

  return (
    <Container maxWidth={false}>
      <PageTitle title="Ajouter un encouragement lors des exercices" />
      {(
        pending || content === null
      ) && <PageCircularProgress />}
      {content !== null
        && (
          <ExerciseEncouragementMessageForm />
        )}
    </Container>
  );
}
